import React, { useState } from 'react';
import { format } from 'date-fns';
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
} from '@web/components/ui/card';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from '@web/components/ui/table';
import { ContractListData } from '@shared/types';
import { ScrollArea } from '@web/components/ui/scroll-area';

import { ContractStatusBadge } from '@web/routes/dashboard/chat/-components/contract-status-badge';
import { TooltipProvider } from '@web/components/ui/tooltip';

export default function ContractTable({
  contracts,
}: {
  contracts: ContractListData[];
}) {
  const [expandedContract, setExpandedContract] = useState<number | null>(null);

  const toggleContract = (contractId: number) => {
    setExpandedContract(expandedContract === contractId ? null : contractId);
  };

  return (
    <TooltipProvider>
      <Table className="w-full border-collapse">
        <TableHeader>
          <TableRow>
            <TableCell className="px-4 py-3 text-left font-bold">
              Name
            </TableCell>
            <TableCell className="px-4 py-3 text-left font-bold">
              Created At
            </TableCell>
            <TableCell className="px-4 py-3 text-left font-bold">
              Status
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {contracts.map((contract, contractIndex) => (
            <React.Fragment key={contractIndex}>
              <TableRow
                onClick={() => {
                  toggleContract(contractIndex);
                }}
                className="cursor-pointer border-b transition-colors duration-200"
              >
                <TableCell className="px-4 py-3 text-gray-800 dark:text-gray-200">
                  {contract.name}
                </TableCell>
                <TableCell className="px-4 py-3 text-gray-800 dark:text-gray-200">
                  {contract.createdAt
                    ? format(new Date(contract.createdAt), 'yyyy/MM/dd')
                    : 'N/A'}
                </TableCell>
                <TableCell className="px-4 py-3">
                  <ContractStatusBadge status={contract.status} />
                </TableCell>
              </TableRow>

              {expandedContract === contractIndex && (
                <TableRow>
                  <TableCell colSpan={5} className="p-4">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                      <Card className="rounded-xl border-2">
                        <CardHeader className="px-4 py-3">
                          <CardTitle className="text-lg font-bold">
                            Procedures
                          </CardTitle>
                        </CardHeader>
                        <CardContent className="p-4">
                          <ScrollArea>
                            <ul className="space-y-2">
                              {contract.procedureContracts.map((procedure) => (
                                <li
                                  key={procedure.procedure.id}
                                  className="text-gray-800 dark:text-gray-200"
                                >
                                  {procedure.procedure.name}
                                </li>
                              ))}
                            </ul>
                          </ScrollArea>
                        </CardContent>
                      </Card>

                      <Card className="rounded-xl border-2">
                        <CardHeader className="px-4 py-3">
                          <CardTitle className="text-lg font-bold">
                            Products
                          </CardTitle>
                        </CardHeader>
                        <CardContent className="p-4">
                          <ScrollArea>
                            <ul className="space-y-2">
                              {contract.productContracts.map((product) => (
                                <li
                                  key={product.product.id}
                                  className="text-gray-800 dark:text-gray-200"
                                >
                                  {product.product.displayName}
                                </li>
                              ))}
                            </ul>
                          </ScrollArea>
                        </CardContent>
                      </Card>

                      {contract.status == 'paid' && (
                        <Card className="rounded-xl border-2">
                          <CardHeader className="px-4 py-3">
                            <CardTitle className="text-lg font-bold">
                              Payments
                            </CardTitle>
                          </CardHeader>
                          <CardContent className="p-4">
                            {/* Payments content */}
                          </CardContent>
                        </Card>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TooltipProvider>
  );
}
